import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/truck-type-import-jobs'
)({
  meta: () => [{ title: MENU.TRUCK_TYPE_IMPORT_HISTORY }]
})
